import nw from '@/nvwa/versionLast'

export default {
    state:{
        notify:{
            show:false,
            message:'',
            marginTop:0,
            type:'warning'
        },
        statusBarHeight:0,
        actionBarHeight:0
    },
    mutations:{
        init(state) {
            nw.getWindowInfo({
                success:res=>{
                    state.statusBarHeight = res.statusBarHeight
                    localStorage.setItem("statusBarHeight", res.statusBarHeight)
                }
            })
        },
        showNotify(state,options){
            let {duration,message,NotActionBar,type}=options
            state.notify.show=true
            state.notify.message=message
            state.notify.type=type?type:'warning'
            const actionBarHeight = parseInt(localStorage.getItem("actionBarHeight") || 0)
            const statusBarHeight = parseInt(localStorage.getItem("statusBarHeight") || state.statusBarHeight || 0)
            if(NotActionBar){
                state.notify.marginTop=statusBarHeight
            }else{
                state.notify.marginTop=actionBarHeight
            }
            if(state.notify.marginTop<=0){
                state.notify.marginTop=statusBarHeight
            }
            setTimeout(()=>{
                state.notify.show=false
            },duration?duration:1500)
        }
    }
}
